import { Trans, useTranslation } from "next-i18next"
import React from "react"
import { Col, Row } from "react-styled-flexboxgrid"
import { Heading } from "@aistihealth/web-common/src/components/heading/Heading"
import { ButtonGroup } from "@aistihealth/web-common/src/components/button-group/ButtonGroup"
import { SingleColLayout } from "@aistihealth/web-common/src/components/single-col-layout/SingleColLayout"
import { defaultIfString, ButtonI18nProps } from "../../util/typing/i18n"
import { NextLinkButton } from "../next-link-button/NextLinkButton"
import { Section } from "../section/Section"
import { nextStepsSectionProps } from "../../util/styles/common-section-props"

export const NextStepsSection: React.FunctionComponent = () => {
  const { t } = useTranslation()
  const { backgroundColor, bottomCut } = nextStepsSectionProps[0]
  const surveyBaseUrl = process.env.NEXT_PUBLIC_WS_EXT_APP_BASE_URL

  const nextStepsButtons: ButtonI18nProps[] = defaultIfString(
    t("nextStepsSection.buttons", {
      returnObjects: true,
      surveyBaseUrl,
    }),
    [],
  )

  return (
    <Section backgroundColor={backgroundColor} bottomCut={bottomCut}>
      <SingleColLayout colProps={{ xs: 12 }}>
        <Heading as="h3" size="xlarge" align="center">
          <Trans i18nKey="nextStepsSection.header" />
        </Heading>
        <Row center="xs">
          <Col>
            <ButtonGroup xs="vertical" sm="horizontal">
              {nextStepsButtons.map(({ text, ...buttonProps }) => {
                return (
                  <NextLinkButton key={text} {...buttonProps}>
                    {text}
                  </NextLinkButton>
                )
              })}
            </ButtonGroup>
          </Col>
        </Row>
      </SingleColLayout>
    </Section>
  )
}
